/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { JobFromJSON, JobToJSON } from './Job';
export function PurgeUserAndMailTemplateOrganizationResponseDataFromJSON(json) {
    return PurgeUserAndMailTemplateOrganizationResponseDataFromJSONTyped(json, false);
}
export function PurgeUserAndMailTemplateOrganizationResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        job: !exists(json, 'job') ? undefined : JobFromJSON(json['job'])
    };
}
export function PurgeUserAndMailTemplateOrganizationResponseDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        job: JobToJSON(value.job)
    };
}
